import React, { useState, useEffect } from 'react';
import { 
  Gauge, 
  Plus, 
  Search, 
  Filter, 
  Edit3, 
  Trash2, 
  Eye, 
  Save,
  RefreshCw,
  CheckCircle,
  AlertTriangle,
  X,
  Activity,
  Users,
  Calendar,
  FileText,
  Database,
  Server,
  Bell,
  Download,
  Upload,
  MoreHorizontal,
  ChevronDown,
  ChevronRight,
  Copy,
  TestTube,
  BarChart3,
  TrendingUp,
  PieChart,
  Timer,
  Zap,
  AlertCircle,
  CheckSquare,
  Square,
  Star,
  Award,
  TrendingDown,
  Percent,
  DollarSign,
  UserCheck,
  UserX,
  Clock3,
  Clock4,
  Clock5,
  Clock6,
  Clock7,
  Clock8,
  Clock9,
  Clock10,
  Clock11,
  Clock12,
  Send,
  Paperclip,
  Image,
  Link,
  Bold,
  Italic,
  Underline,
  AlignLeft,
  AlignCenter,
  AlignRight,
  List,
  Quote,
  Code,
  Palette,
  Type,
  Layout,
  Monitor,
  Smartphone,
  Tablet,
  Key,
  Lock,
  Unlock,
  Globe,
  Wifi,
  HardDrive,
  Cpu,
  Network,
  Mail,
  Phone,
  MapPin,
  Calendar as CalendarIcon,
  Clock,
  Sun,
  Moon,
  Cloud,
  CloudRain,
  CloudSnow,
  Wind,
  Thermometer,
  Droplets,
  Gauge as GaugeIcon,
  Zap as ZapIcon,
  Battery,
  WifiOff,
  Signal,
  SignalZero,
  SignalLow,
  SignalMedium,
  SignalHigh,
  SignalMax,
  UserPlus,
  UserMinus,
  Settings as SettingsIcon,
  Home,
  Office,
  Factory,
  Store,
  School,
  Hospital,
  Bank,
  Briefcase,
  GraduationCap,
  Stethoscope,
  CreditCard,
  ShoppingCart,
  BookOpen,
  Heart,
  DollarSign as DollarSignIcon,
  Crown,
  Badge,
  Award as AwardIcon,
  Medal,
  Trophy,
  Certificate,
  Diploma,
  GraduationCap as GraduationCapIcon,
  UserCog,
  UserShield,
  UserCheck as UserCheckIcon,
  UserX as UserXIcon,
  UserPlus as UserPlusIcon,
  UserMinus as UserMinusIcon,
  UserEdit,
  UserSettings,
  UserSearch,
  UserClock,
  UserStar,
  UserHeart,
  UserSmile,
  UserFrown,
  UserMeh,
  UserCheck2,
  UserX2,
  UserPlus2,
  UserMinus2,
  UserEdit2,
  UserSettings2,
  UserSearch2,
  UserClock2,
  UserStar2,
  UserHeart2,
  UserSmile2,
  UserFrown2,
  UserMeh2,
  Archive,
  ArchiveRestore,
  ArchiveX,
  ArchiveCheck,
  ArchivePlus,
  ArchiveMinus,
  ArchiveEdit,
  ArchiveSettings,
  ArchiveSearch,
  ArchiveClock,
  ArchiveStar,
  ArchiveHeart,
  ArchiveSmile,
  ArchiveFrown,
  ArchiveMeh,
  ArchiveCheck2,
  ArchiveX2,
  ArchivePlus2,
  ArchiveMinus2,
  ArchiveEdit2,
  ArchiveSettings2,
  ArchiveSearch2,
  ArchiveClock2,
  ArchiveStar2,
  ArchiveHeart2,
  ArchiveSmile2,
  ArchiveFrown2,
  ArchiveMeh2
} from 'lucide-react';
import MockDataService from '../../services/MockDataService';

const SystemPerformance = () => {
  const [performanceData, setPerformanceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('metrics');
  const [showMetricForm, setShowMetricForm] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterCategory, setFilterCategory] = useState('all');
  const [expandedMetrics, setExpandedMetrics] = useState(new Set());
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  useEffect(() => {
    const fetchPerformanceData = async () => {
      try {
        setLoading(true);
        const response = await MockDataService.getSystemPerformance();
        if (response.success) {
          setPerformanceData(response.data);
        } else {
          setError('Failed to load system performance data');
        }
      } catch (err) {
        setError('Error loading system performance data');
        console.error('System performance data error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPerformanceData();
  }, []);

  const handleCreateMetric = () => {
    setSelectedMetric(null);
    setShowMetricForm(true);
  };

  const handleEditMetric = (metric) => {
    setSelectedMetric(metric);
    setShowMetricForm(true);
  };

  const handleCloseMetricForm = () => {
    setShowMetricForm(false);
    setSelectedMetric(null);
    setHasUnsavedChanges(false);
  };

  const handleSubmitMetric = (metricData) => {
    //console.log('Submitting metric:', metricData);
    setShowMetricForm(false);
    setSelectedMetric(null);
    setHasUnsavedChanges(false);
  };

  const handleDeleteMetric = (metricId) => {
    if (window.confirm('Are you sure you want to delete this metric?')) {
      //console.log('Deleting metric:', metricId);
    }
  };

  const handleTestMetric = (metricId) => {
    //console.log('Testing metric:', metricId);
  };

  const toggleMetricExpansion = (metricId) => {
    const newExpanded = new Set(expandedMetrics);
    if (newExpanded.has(metricId)) {
      newExpanded.delete(metricId);
    } else {
      newExpanded.add(metricId);
    }
    setExpandedMetrics(newExpanded);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading system performance...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <AlertTriangle className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <p className="text-red-600 dark:text-red-400">{error}</p>
        </div>
      </div>
    );
  }

  if (!performanceData) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-400">No system performance data available</p>
        </div>
      </div>
    );
  }

  const { 
    systemPerformance, 
    performanceStats, 
    recentActivity, 
    performanceAnalytics
  } = performanceData;

  const { performanceMetrics, performanceAlerts, performanceReports, optimizationTasks } = systemPerformance;

  const tabs = [
    { id: 'metrics', label: 'Metrics', icon: Gauge },
    { id: 'alerts', label: 'Alerts', icon: Bell },
    { id: 'reports', label: 'Reports', icon: FileText },
    { id: 'optimization', label: 'Optimization', icon: Zap }
  ];

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'api': return Server;
      case 'server': return Cpu;
      case 'database': return Database;
      case 'network': return Network;
      default: return Gauge;
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'api': return 'blue';
      case 'server': return 'green';
      case 'database': return 'orange';
      case 'network': return 'purple';
      default: return 'blue';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'good': return 'text-green-600 dark:text-green-400';
      case 'warning': return 'text-yellow-600 dark:text-yellow-400';
      case 'critical': return 'text-red-600 dark:text-red-400';
      default: return 'text-gray-600 dark:text-gray-400';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'good': return CheckCircle;
      case 'warning': return AlertTriangle;
      case 'critical': return X;
      default: return CheckCircle;
    }
  };

  const getTrendIcon = (trend) => {
    switch (trend) {
      case 'increasing': return TrendingUp;
      case 'decreasing': return TrendingDown;
      case 'stable': return Activity;
      default: return Activity;
    }
  };

  const getTrendColor = (trend) => {
    switch (trend) {
      case 'increasing': return 'text-red-600 dark:text-red-400';
      case 'decreasing': return 'text-green-600 dark:text-green-400';
      case 'stable': return 'text-blue-600 dark:text-blue-400';
      default: return 'text-gray-600 dark:text-gray-400';
    }
  };

  const filteredMetrics = performanceMetrics.filter(metric => {
    const matchesSearch = metric.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         metric.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = filterStatus === 'all' || metric.status === filterStatus;
    const matchesCategory = filterCategory === 'all' || metric.category === filterCategory;
    return matchesSearch && matchesStatus && matchesCategory;
  });

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-4">
              <Gauge className="h-8 w-8 text-blue-600 dark:text-blue-400" />
              <div>
                <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                  System Performance
                </h1>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Monitor and optimize system performance metrics
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              {hasUnsavedChanges && (
                <div className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-orange-600 dark:text-orange-400 bg-orange-100 dark:bg-orange-900 rounded-md">
                  <AlertTriangle className="h-4 w-4" />
                  <span>Unsaved Changes</span>
                </div>
              )}
              <button className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors">
                <Download className="h-4 w-4" />
                <span>Export</span>
              </button>
              <button
                onClick={handleCreateMetric}
                className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
              >
                <Plus className="h-4 w-4" />
                <span>Add Metric</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Performance Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <div className="p-2 bg-blue-100 dark:bg-blue-900 rounded-lg">
                <Gauge className="h-6 w-6 text-blue-600 dark:text-blue-400" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Total Metrics</p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{performanceStats.totalMetrics}</p>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <div className="p-2 bg-orange-100 dark:bg-orange-900 rounded-lg">
                <Bell className="h-6 w-6 text-orange-600 dark:text-orange-400" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Active Alerts</p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{performanceStats.activeAlerts}</p>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <div className="p-2 bg-green-100 dark:bg-green-900 rounded-lg">
                <TrendingUp className="h-6 w-6 text-green-600 dark:text-green-400" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Performance Score</p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{performanceStats.performanceScore}</p>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <div className="p-2 bg-purple-100 dark:bg-purple-900 rounded-lg">
                <Activity className="h-6 w-6 text-purple-600 dark:text-purple-400" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">System Uptime</p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{performanceStats.systemUptime}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Sidebar Navigation */}
          <div className="lg:col-span-1">
            <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Performance</h3>
                <nav className="space-y-2">
                  {tabs.map((tab) => {
                    const Icon = tab.icon;
                    return (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`w-full flex items-center space-x-3 px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                          activeTab === tab.id
                            ? 'bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300'
                            : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                        }`}
                      >
                        <Icon className="h-4 w-4" />
                        <span>{tab.label}</span>
                      </button>
                    );
                  })}
                </nav>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-3">
            <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
              {/* Metrics Tab */}
              {activeTab === 'metrics' && (
                <div className="p-6">
                  <div className="flex items-center justify-between mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Performance Metrics</h2>
                    <div className="flex items-center space-x-2">
                      <button className="flex items-center space-x-1 px-3 py-1 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300">
                        <RefreshCw className="h-4 w-4" />
                        <span>Refresh</span>
                      </button>
                    </div>
                  </div>

                  {/* Search and Filters */}
                  <div className="flex flex-col sm:flex-row gap-4 mb-6">
                    <div className="flex-1">
                      <div className="relative">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                        <input
                          type="text"
                          placeholder="Search metrics..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                        />
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <select
                        value={filterStatus}
                        onChange={(e) => setFilterStatus(e.target.value)}
                        className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                      >
                        <option value="all">All Status</option>
                        <option value="good">Good</option>
                        <option value="warning">Warning</option>
                        <option value="critical">Critical</option>
                      </select>
                      <select
                        value={filterCategory}
                        onChange={(e) => setFilterCategory(e.target.value)}
                        className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                      >
                        <option value="all">All Categories</option>
                        <option value="api">API</option>
                        <option value="server">Server</option>
                        <option value="database">Database</option>
                        <option value="network">Network</option>
                      </select>
                    </div>
                  </div>

                  {/* Metrics List */}
                  <div className="space-y-3">
                    {filteredMetrics.map((metric) => {
                      const CategoryIcon = getCategoryIcon(metric.category);
                      const StatusIcon = getStatusIcon(metric.status);
                      const TrendIcon = getTrendIcon(metric.trend);
                      const isExpanded = expandedMetrics.has(metric.id);
                      
                      return (
                        <div key={metric.id} className="border border-gray-200 dark:border-gray-700 rounded-lg">
                          <div className="flex items-center justify-between p-4">
                            <div className="flex items-center space-x-4">
                              <button
                                onClick={() => toggleMetricExpansion(metric.id)}
                                className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
                              >
                                {isExpanded ? (
                                  <ChevronDown className="h-4 w-4 text-gray-400" />
                                ) : (
                                  <ChevronRight className="h-4 w-4 text-gray-400" />
                                )}
                              </button>
                              <div className={`p-2 bg-${getCategoryColor(metric.category)}-100 dark:bg-${getCategoryColor(metric.category)}-900 rounded-lg`}>
                                <CategoryIcon className={`h-4 w-4 text-${getCategoryColor(metric.category)}-600 dark:text-${getCategoryColor(metric.category)}-400`} />
                              </div>
                              <div className="flex-1">
                                <div className="flex items-center space-x-2 mb-1">
                                  <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100">{metric.name}</h3>
                                  <span className="text-xs text-gray-500 dark:text-gray-400">{metric.category}</span>
                                </div>
                                <p className="text-sm text-gray-600 dark:text-gray-400">{metric.description}</p>
                              </div>
                            </div>
                            <div className="flex items-center space-x-2">
                              <div className="text-right">
                                <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                                  {metric.currentValue} {metric.unit}
                                </div>
                                <div className="flex items-center space-x-1">
                                  <TrendIcon className={`h-3 w-3 ${getTrendColor(metric.trend)}`} />
                                  <span className={`text-xs ${getTrendColor(metric.trend)}`}>{metric.trend}</span>
                                </div>
                              </div>
                              <StatusIcon className={`h-4 w-4 ${getStatusColor(metric.status)}`} />
                              <span className={`text-xs font-medium px-2 py-1 rounded-full ${
                                metric.status === 'good' ? 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200' :
                                metric.status === 'warning' ? 'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200' :
                                'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200'
                              }`}>
                                {metric.status}
                              </span>
                              <div className="flex items-center space-x-1">
                                <button
                                  onClick={() => handleTestMetric(metric.id)}
                                  className="p-1 hover:bg-gray-200 dark:hover:bg-gray-600 rounded"
                                  title="Test Metric"
                                >
                                  <TestTube className="h-4 w-4 text-gray-400" />
                                </button>
                                <button
                                  onClick={() => handleEditMetric(metric)}
                                  className="p-1 hover:bg-gray-200 dark:hover:bg-gray-600 rounded"
                                >
                                  <Edit3 className="h-4 w-4 text-gray-400" />
                                </button>
                                <button
                                  onClick={() => handleDeleteMetric(metric.id)}
                                  className="p-1 hover:bg-gray-200 dark:hover:bg-gray-600 rounded"
                                >
                                  <Trash2 className="h-4 w-4 text-gray-400" />
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* Expanded Metric Details */}
                          {isExpanded && (
                            <div className="border-t border-gray-200 dark:border-gray-700 p-4 bg-gray-50 dark:bg-gray-700">
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                  <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">Metric Details</h4>
                                  <div className="space-y-2">
                                    <div className="flex justify-between text-sm">
                                      <span className="text-gray-600 dark:text-gray-400">Threshold:</span>
                                      <span className="text-gray-900 dark:text-gray-100">{metric.threshold} {metric.unit}</span>
                                    </div>
                                    <div className="flex justify-between text-sm">
                                      <span className="text-gray-600 dark:text-gray-400">Last Updated:</span>
                                      <span className="text-gray-900 dark:text-gray-100">{new Date(metric.lastUpdated).toLocaleString()}</span>
                                    </div>
                                    <div className="flex justify-between text-sm">
                                      <span className="text-gray-600 dark:text-gray-400">Trend:</span>
                                      <span className="text-gray-900 dark:text-gray-100">{metric.trend}</span>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">Recent History</h4>
                                  <div className="space-y-1">
                                    {metric.history.slice(-3).map((entry, index) => (
                                      <div key={index} className="flex justify-between text-sm">
                                        <span className="text-gray-600 dark:text-gray-400">{new Date(entry.timestamp).toLocaleTimeString()}</span>
                                        <span className="text-gray-900 dark:text-gray-100">{entry.value} {metric.unit}</span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Other tabs would be implemented similarly */}
              {activeTab === 'alerts' && (
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6">Performance Alerts</h2>
                  <p className="text-gray-600 dark:text-gray-400">Performance alerts coming soon...</p>
                </div>
              )}

              {activeTab === 'reports' && (
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6">Performance Reports</h2>
                  <p className="text-gray-600 dark:text-gray-400">Performance reports coming soon...</p>
                </div>
              )}

              {activeTab === 'optimization' && (
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6">Optimization Tasks</h2>
                  <p className="text-gray-600 dark:text-gray-400">Optimization tasks coming soon...</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Metric Form Modal */}
      {showMetricForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-2xl mx-4">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                {selectedMetric ? 'Edit Metric' : 'Add New Metric'}
              </h3>
              <button
                onClick={handleCloseMetricForm}
                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Metric Name
                  </label>
                  <input
                    type="text"
                    defaultValue={selectedMetric?.name || ''}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                    placeholder="Enter metric name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Category
                  </label>
                  <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100">
                    <option value="api">API</option>
                    <option value="server">Server</option>
                    <option value="database">Database</option>
                    <option value="network">Network</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Description
                </label>
                <textarea
                  rows={3}
                  defaultValue={selectedMetric?.description || ''}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                  placeholder="Enter metric description"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Threshold
                  </label>
                  <input
                    type="number"
                    defaultValue={selectedMetric?.threshold || ''}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                    placeholder="Enter threshold value"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Unit
                  </label>
                  <input
                    type="text"
                    defaultValue={selectedMetric?.unit || ''}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                    placeholder="e.g., ms, %, MB"
                  />
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end space-x-3 mt-6">
              <button
                onClick={handleCloseMetricForm}
                className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={() => handleSubmitMetric({})}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
              >
                {selectedMetric ? 'Update Metric' : 'Add Metric'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SystemPerformance;
